import { useEffect } from "react";

type Config = {
    successCallback: PositionCallback;
    errorCallback: PositionErrorCallback;
};

export const useGetUserPosition = ({ errorCallback, successCallback }: Config) => {
    useEffect(() => {
        navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
    }, []);
};
